
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { jsPDF } from "jspdf";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) return;

//     fetch(`${BASE_API_URL}/api/contracts/${userId}`)
//       .then((res) => res.json())
//       .then((data) => setContracts(data.contracts || []))
//       .catch((err) => console.error("Error fetching contracts:", err));
//   }, []);

//   // ------------------ Download Contract PDF ------------------
//   // const downloadContractPDF = async (transactionId) => {
//   //   try {
//   //     const res = await fetch(`http://localhost:8000/api/contract/${transactionId}`);
//   //     if (!res.ok) throw new Error("Failed to fetch contract");
//   //     const data = await res.json();

//   //     const doc = new jsPDF();
//   //     doc.setFontSize(12);
//   //     doc.text(data.contractText, 10, 10);
//   //     doc.save(`Contract_${transactionId}.pdf`);
//   //   } catch (err) {
//   //     console.error("Error downloading PDF:", err);
//   //     alert("Failed to download contract PDF");
//   //   }
//   // };
// const downloadContractPDF = async (transactionId) => {
//   try {
//     const res = await fetch(`${BASE_API_URL}/api/contracts/view/${transactionId}`);
//     if (!res.ok) throw new Error("Failed to fetch contract PDF");

//     const data = await res.json();
//     if (data && data.pdf_base64) {
//       // Convert Base64  Blob  Download
//       const byteCharacters = atob(data.pdf_base64);
//       const byteNumbers = new Array(byteCharacters.length);
//       for (let i = 0; i < byteCharacters.length; i++) {
//         byteNumbers[i] = byteCharacters.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       const blob = new Blob([byteArray], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `Contract_${transactionId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
//     } else {
//       alert("No contract PDF found for this transaction.");
//     }
//   } catch (err) {
//     console.error("Error downloading PDF:", err);
//     alert(" Failed to download contract PDF.");
//   }
// };

//   return (
//     <>
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div><strong>Project ID:</strong> {contract.projectId}</div>
//                   <div><strong>Project Title:</strong> {contract.title}</div>
//                   <div><strong>Transaction ID:</strong> {contract.transactionId}</div>
//                 </div>
//                 <div className="cl-contract-actions">
//                   <div className={`cl-contract-status ${contract.status?.toLowerCase()}`}>
//                     {contract.status || "Draft"}
//                   </div>
//                   {/* Download Button */}
//                   {/* <button 
//                     className="btn-download"
//                     onClick={() => downloadContractPDF(contract.transactionId)}
//                   >
//                     Download Contract
//                   </button> */}
//                   <button
//   className="btn btn-secondary"
//   onClick={() => downloadContractPDF(contract.transactionId)}
// >
//    Download
// </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;








// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ------------------ Fetch Contracts ------------------
//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) return;

//     fetch(`${BASE_API_URL}/api/contracts/${userId}`)
//       .then((res) => res.json())
//       .then((data) => setContracts(data.contracts || []))
//       .catch((err) => console.error("Error fetching contracts:", err));
//   }, []);

//   // ------------------ Download Document PDF ------------------
//   const downloadContractPDF = async () => {
//     try {
//       const documentId = sessionStorage.getItem("document_id"); //  get from session storage
//       if (!documentId) {
//         alert(" No document_id found in session storage!");
//         return;
//       }

//       const url = `http://localhost:8002/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);

//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       // Convert the response into a Blob
//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       // Create a temporary download link
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Release the blob URL memory
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     }
//   };

//   return (
//     <>
//       {/* Optional Sidebar */}
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div>
//                     <strong>Project ID:</strong> {contract.projectId}
//                   </div>
//                   <div>
//                     <strong>Project Title:</strong> {contract.title}
//                   </div>
//                   <div>
//                     <strong>Transaction ID:</strong> {contract.transactionId}
//                   </div>
//                 </div>

//                 <div className="cl-contract-actions">
//                   <div
//                     className={`cl-contract-status ${
//                       contract.status?.toLowerCase() || "draft"
//                     }`}
//                   >
//                     {contract.status || "Draft"}
//                   </div>

//                   {/*  Download Button */}
//                   <button
//                     className="btn btn-secondary"
//                     onClick={downloadContractPDF}
//                   >
//                      Download
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;








// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ------------------ Fetch Contracts ------------------
//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         // Step 1 Fetch contracts list
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();

//         if (!data.contracts) {
//           console.error("No contracts found:", data);
//           return;
//         }

//         // Step 2 For each contract, fetch document_id using /api/contracts/get-document
//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               const docRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId: userId,
//                 }),
//               });

//               if (!docRes.ok) {
//                 console.warn(`No document found for transactionId ${contract.transactionId}`);
//                 return { ...contract, document_id: null };
//               }

//               const docData = await docRes.json();
//               // Store document_id for download use
//               sessionStorage.setItem("document_id", docData.document_id);
//               return { ...contract, document_id: docData.document_id };
//             } catch (err) {
//               console.error("Error fetching document_id:", err);
//               return { ...contract, document_id: null };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   // ------------------ Download Document PDF ------------------
//   const downloadContractPDF = async (documentId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);

//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       // Convert the response into a Blob
//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       // Create a temporary download link
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Release the blob URL memory
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     }
//   };

//   return (
//     <>
//       {/* Optional Sidebar */}
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div>
//                     <strong>Project ID:</strong> {contract.projectId}
//                   </div>
//                   <div>
//                     <strong>Project Title:</strong> {contract.title}
//                   </div>
//                   <div>
//                     <strong>Transaction ID:</strong> {contract.transactionId}
//                   </div>

//                   {/*  Show document_id below Transaction ID */}
//                   {contract.document_id ? (
//                     <div>
//                       <strong>Document ID:</strong> {contract.document_id}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       <em style={{color:'grey'}}>No contract signed given TransactionID and userId...</em>
//                     </div>
//                   )}
//                 </div>

//                 <div className="cl-contract-actions">
//                   <div
//                     className={`cl-contract-status ${
//                       contract.status?.toLowerCase() || "draft"
//                     }`}
//                   >
//                     {contract.status || "Draft"}
//                   </div>

//                   {/*  Download Button */}
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => downloadContractPDF(contract.document_id)}
//                     disabled={!contract.document_id}
//                   >
//                      Download
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;














// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ------------------ Fetch Contracts ------------------
//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         // Step 1 Fetch contracts list
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();

//         if (!data.contracts) {
//           console.error("No contracts found:", data);
//           return;
//         }

//         // Step 2 For each contract, fetch document_id using /api/contracts/get-document-id
//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               const docRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId: userId,
//                 }),
//               });

//               if (!docRes.ok) {
//                 console.warn(`No document found for transactionId ${contract.transactionId}`);
//                 return { ...contract, document_id: null };
//               }

//               const docData = await docRes.json();
//               return { ...contract, document_id: docData.document_id || null };
//             } catch (err) {
//               console.error("Error fetching document_id:", err);
//               return { ...contract, document_id: null };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   // ------------------ Download Document PDF ------------------
//   const downloadContractPDF = async (documentId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);

//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       // Convert the response into a Blob
//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       // Create a temporary download link
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Release the blob URL memory
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     }
//   };

//   return (
//     <>
//       {/* Optional Sidebar */}
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div>
//                     <strong>Project ID:</strong> {contract.projectId}
//                   </div>
//                   <div>
//                     <strong>Project Title:</strong> {contract.title}
//                   </div>
//                   <div>
//                     <strong>Transaction ID:</strong> {contract.transactionId}
//                   </div>

//                   {/*  Show document_id below Transaction ID */}
//                   {contract.document_id ? (
//                     <div>
//                       <strong>Document ID:</strong> {contract.document_id}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       <em style={{ color: "grey" }}>
//                         No contract signed for given TransactionId & UserId...
//                       </em>
//                     </div>
//                   )}
//                 </div>

//                 <div className="cl-contract-actions">
//                   <div
//                     className={`cl-contract-status ${
//                       contract.status?.toLowerCase() || "draft"
//                     }`}
//                   >
//                     {contract.status || "Draft"}
//                   </div>

//                   {/*  Download Button */}
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => downloadContractPDF(contract.document_id)}
//                     disabled={!contract.document_id}
//                   >
//                      Download
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;









// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [loadingDocId, setLoadingDocId] = useState(null); //  track which button is loading
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ------------------ Fetch Contracts ------------------
//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         // Step 1 Fetch contracts list
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();

//         if (!data.contracts) {
//           console.error("No contracts found:", data);
//           return;
//         }

//         // Step 2 For each contract, fetch document_id using /api/contracts/get-document-id
//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               const docRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId: userId,
//                 }),
//               });

//               if (!docRes.ok) {
//                 console.warn(`No document found for transactionId ${contract.transactionId}`);
//                 return { ...contract, document_id: null };
//               }

//               const docData = await docRes.json();
//               return { ...contract, document_id: docData.document_id || null };
//             } catch (err) {
//               console.error("Error fetching document_id:", err);
//               return { ...contract, document_id: null };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   // ------------------ Download Document PDF ------------------
//   const downloadContractPDF = async (documentId, transactionId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       setLoadingDocId(transactionId); //  start spinner

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);

//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       // Convert the response into a Blob
//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       // Create a temporary download link
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Release the blob URL memory
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     } finally {
//       setLoadingDocId(null); //  stop spinner
//     }
//   };

//   return (
//     <>
//       {/* Optional Sidebar */}
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div>
//                     <strong>Project ID:</strong> {contract.projectId}
//                   </div>
//                   <div>
//                     <strong>Project Title:</strong> {contract.title}
//                   </div>
//                   <div>
//                     <strong>Transaction ID:</strong> {contract.transactionId}
//                   </div>

//                   {/*  Show document_id below Transaction ID */}
//                   {contract.document_id ? (
//                     <div>
//                       <strong>Document ID:</strong> {contract.document_id}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       <em style={{ color: "grey" }}>
//                         No contract signed for given TransactionId & UserId...
//                       </em>
//                     </div>
//                   )}
//                 </div>

//                 <div className="cl-contract-actions">
//                   <div
//                     className={`cl-contract-status ${contract.status?.toLowerCase() || "draft"
//                       }`}
//                   >
//                     {contract.status || "Draft"}
//                   </div>

//                   {/*  Download Button with Spinner */}
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() =>
//                       downloadContractPDF(contract.document_id, contract.transactionId)
//                     }
//                     disabled={!contract.document_id || loadingDocId === contract.transactionId}
//                   >
//                     {loadingDocId === contract.transactionId ? (
//                         <div
//                           className="pdf-loading"
//                           style={{
//                             flexDirection: "row",
//                             alignItems: "center",
//                             gap: "8px",
//                             padding: 0,
//                           }}
//                         >
//                           <div
//                             className="spinner"
//                             style={{
//                               width: "16px",
//                               height: "16px",
//                               borderWidth: "2px",
//                               marginBottom: 0,
//                             }}
//                           ></div>
//                           <span>Loading...</span>
//                         </div>
//                     ) : (
//                       " Download"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;



// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [loadingDocId, setLoadingDocId] = useState(null); // track which button is loading
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ------------------ Fetch Contracts ------------------
//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         // Step 1: Fetch contracts list
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();
//         if (!data.contracts) return;

//         // Step 2: For each contract, fetch document details from Digio API
//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               // Get document_id first
//               const docIdRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId: userId,
//                 }),
//               });

//               if (!docIdRes.ok) return { ...contract, document_id: null, signing_statuses: [] };

//               const docIdData = await docIdRes.json();
//               const documentId = docIdData.document_id;

//               if (!documentId) return { ...contract, document_id: null, signing_statuses: [] };

//               // Fetch full document details from Digio
//               const docDetailsRes = await fetch(`${BASE_API_URL}/get-doc-details/${documentId}`);
//               if (!docDetailsRes.ok) return { ...contract, document_id: documentId, signing_statuses: [] };

//               const docDetails = await docDetailsRes.json();
//               const signingParties = docDetails.data.signing_parties || [];

//               // Extract all statuses from signing_parties
//               const signingStatuses = signingParties.map((party) => party.status);

//               return {
//                 ...contract,
//                 document_id: documentId,
//                 signing_statuses: signingStatuses,
//               };
//             } catch (err) {
//               console.error("Error fetching document details:", err);
//               return { ...contract, document_id: null, signing_statuses: [] };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   // ------------------ Download Document PDF ------------------
//   const downloadContractPDF = async (documentId, transactionId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       setLoadingDocId(transactionId);

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     } finally {
//       setLoadingDocId(null);
//     }
//   };

//   return (
//     <>
//       {/* Optional Sidebar */}
//       {/* <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       /> */}

//       <div className="cl-app-container">
//         <main className="cl-main-content">
//           <h1 className="cl-page-title">Contracts List</h1>

//           {contracts.length === 0 && <p>No contracts found.</p>}

//           <div className="cl-contracts-container">
//             {contracts.map((contract, idx) => (
//               <div key={idx} className="cl-contract-card">
//                 <div className="cl-contract-info">
//                   <div>
//                     <strong>Project ID:</strong> {contract.projectId}
//                   </div>
//                   <div>
//                     <strong>Project Title:</strong> {contract.title}
//                   </div>
//                   <div>
//                     <strong>Transaction ID:</strong> {contract.transactionId}
//                   </div>

//                   {contract.document_id ? (
//                     <div>
//                       <strong>Document ID:</strong> {contract.document_id}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       <em style={{ color: "grey" }}>
//                         No contract signed for given TransactionId & UserId...
//                       </em>
//                     </div>
//                   )}

//                   {/*  Display all signing statuses */}
//                   {contract.signing_statuses && contract.signing_statuses.length > 0 && (
//                     <div>
//                       <strong>Status:</strong>{" "}
//                       {contract.signing_statuses.join(", ")}
//                     </div>
//                   )}
//                 </div>

//                 <div className="cl-contract-actions">
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() =>
//                       downloadContractPDF(contract.document_id, contract.transactionId)
//                     }
//                     disabled={!contract.document_id || loadingDocId === contract.transactionId}
//                   >
//                     {loadingDocId === contract.transactionId ? (
//                       <div
//                         className="pdf-loading"
//                         style={{
//                           flexDirection: "row",
//                           alignItems: "center",
//                           gap: "8px",
//                           padding: 0,
//                         }}
//                       >
//                         <div
//                           className="spinner"
//                           style={{
//                             width: "16px",
//                             height: "16px",
//                             borderWidth: "2px",
//                             marginBottom: 0,
//                           }}
//                         ></div>
//                         <span>Loading...</span>
//                       </div>
//                     ) : (
//                       " Download"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default ContractsListPage;










// import React, { useEffect, useState } from "react";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [loadingDocId, setLoadingDocId] = useState(null);

//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();
//         if (!data.contracts) return;

//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               // Step 1 Get document_id
//               const docIdRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId,
//                 }),
//               });

//               if (!docIdRes.ok) return { ...contract, document_id: null };

//               const docIdData = await docIdRes.json();
//               const documentId = docIdData.document_id;
//               if (!documentId) return { ...contract, document_id: null };

//               // Step 2 Fetch document details (statuses)
//               const docDetailsRes = await fetch(`${BASE_API_URL}/get-doc-details/${documentId}`);
//               if (!docDetailsRes.ok) return { ...contract, document_id: documentId };

//               const docDetails = await docDetailsRes.json();
//               const signingParties = docDetails.data.signing_parties || [];

//               // Map company and contributor statuses
//               const companyParty = signingParties.find(
//                 (p) => p.identifier === "legal@cinevestor.in"
//               );
//               const contributorParty = signingParties.find(
//                 (p) => p.identifier !== "legal@cinevestor.in"
//               );

//               return {
//                 ...contract,
//                 document_id: documentId,
//                 company_status: companyParty ? companyParty.status : "N/A",
//                 contributor_status: contributorParty ? contributorParty.status : "N/A",
//               };
//             } catch (err) {
//               console.error("Error fetching document details:", err);
//               return { ...contract, document_id: null };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   const downloadContractPDF = async (documentId, transactionId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       setLoadingDocId(transactionId);

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     } finally {
//       setLoadingDocId(null);
//     }
//   };

//   const getStatusClass = (status) => {
//     switch (status?.toLowerCase()) {
//       case "requested":
//         return "status-requested";
//       case "sequenced":
//         return "status-sequenced";
//       case "completed":
//         return "status-completed";
//       case "failed":
//         return "status-failed";
//       default:
//         return "status-default";
//     }
//   };

//   return (
//     <div className="cl-app-container">
//       <main className="cl-main-content">
//         <h1 className="cl-page-title">Contracts List</h1>

//         {contracts.length === 0 && <p>No contracts found.</p>}

//         <div className="cl-contracts-container">
//           {contracts.map((contract, idx) => (
//             <div key={idx} className="cl-contract-card">
//               <div className="cl-contract-info">
//                 <div><strong>Project ID:</strong> {contract.projectId}</div>
//                 <div><strong>Project Title:</strong> {contract.title}</div>
//                 <div><strong>Transaction ID:</strong> {contract.transactionId}</div>

//                 {contract.document_id ? (
//                   <div><strong>Document ID:</strong> {contract.document_id}</div>
//                 ) : (
//                   <div className="text-muted">
//                     <em style={{ color: "grey" }}>No contract signed for this TransactionId.</em>
//                   </div>
//                 )}
//               </div>

//               <div className="cl-contract-actions">
//                 {/*  Company & Contributor Statuses */}
//                 <div className="dual-status-container">
//                   <span className="status-label">
//                     <strong> Company:</strong>{" "}
//                     <span className={`status-badge ${getStatusClass(contract.company_status)}`}>
//                       {contract.company_status}
//                     </span>
//                   </span>
//                   <span className="status-separator">|</span>
//                   <span className="status-label">
//                     <strong> Contributor:</strong>{" "}
//                     <span className={`status-badge ${getStatusClass(contract.contributor_status)}`}>
//                       {contract.contributor_status}
//                     </span>
//                   </span>
//                 </div>

//                 {/*  Download Button */}
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => downloadContractPDF(contract.document_id, contract.transactionId)}
//                   disabled={!contract.document_id || loadingDocId === contract.transactionId}
//                 >
//                   {loadingDocId === contract.transactionId ? (
//                     <div className="pdf-loading">
//                       <div className="spinner"></div>
//                       <span>Loading...</span>
//                     </div>
//                   ) : (
//                     " Download"
//                   )}
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ContractsListPage;






// import React, { useEffect, useState } from "react";
// import "../CSS/contractsList.css";
// import { BASE_API_URL } from "../constant";

// const ContractsListPage = () => {
//   const [contracts, setContracts] = useState([]);
//   const [loadingDocId, setLoadingDocId] = useState(null);

//   useEffect(() => {
//     const fetchContracts = async () => {
//       const userId = sessionStorage.getItem("userId");
//       if (!userId) return;

//       try {
//         const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
//         const data = await res.json();
//         if (!data.contracts) return;

//         const updatedContracts = await Promise.all(
//           data.contracts.map(async (contract) => {
//             try {
//               // Step 1 Get document_id
//               const docIdRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   transactionId: contract.transactionId,
//                   userId,
//                 }),
//               });

//               if (!docIdRes.ok)
//                 return { ...contract, document_id: null, company_status: "Pending", contributor_status: "Pending" };

//               const docIdData = await docIdRes.json();
//               const documentId = docIdData.document_id;

//               // If no document ID, mark as pending
//               if (!documentId)
//                 return { ...contract, document_id: null, company_status: "Pending", contributor_status: "Pending" };

//               // Step 2 Fetch document details (statuses)
//               const docDetailsRes = await fetch(`${BASE_API_URL}/get-doc-details/${documentId}`);
//               if (!docDetailsRes.ok)
//                 return { ...contract, document_id: documentId, company_status: "Pending", contributor_status: "Pending" };

//               const docDetails = await docDetailsRes.json();
//               const signingParties = docDetails?.data?.signing_parties || [];

//               // Map company and contributor statuses
//               const companyParty = signingParties.find(
//                 (p) => p.identifier === "legal@cinevestor.in"
//               );
//               const contributorParty = signingParties.find(
//                 (p) => p.identifier !== "legal@cinevestor.in"
//               );

//               return {
//                 ...contract,
//                 document_id: documentId,
//                 company_status: companyParty?.status || "Pending",
//                 contributor_status: contributorParty?.status || "Pending",
//               };
//             } catch (err) {
//               console.error("Error fetching document details:", err);
//               return { ...contract, document_id: null, company_status: "Pending", contributor_status: "Pending" };
//             }
//           })
//         );

//         setContracts(updatedContracts);
//       } catch (err) {
//         console.error("Error fetching contracts:", err);
//       }
//     };

//     fetchContracts();
//   }, []);

//   const downloadContractPDF = async (documentId, transactionId) => {
//     try {
//       if (!documentId) {
//         alert(" No document_id found!");
//         return;
//       }

//       setLoadingDocId(transactionId);

//       const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error("Failed to fetch PDF");

//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `Contract_${documentId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Error downloading PDF:", err);
//       alert(" Failed to download the document.");
//     } finally {
//       setLoadingDocId(null);
//     }
//   };

//   const getStatusClass = (status) => {
//     switch (status?.toLowerCase()) {
//       case "requested":
//         return "status-requested";
//       case "sequenced":
//         return "status-sequenced";
//       case "completed":
//         return "status-completed";
//       case "failed":
//         return "status-failed";
//       case "pending":
//         return "status-pending";
//       default:
//         return "status-default";
//     }
//   };

//   return (
//     <div className="cl-app-container">
//       <main className="cl-main-content">
//         <h1 className="cl-page-title">Contracts List</h1>

//         {contracts.length === 0 && <p>No contracts found.</p>}

//         <div className="cl-contracts-container">
//           {contracts.map((contract, idx) => (
//             <div key={idx} className="cl-contract-card">
//               <div className="cl-contract-info">
//                 <div><strong>Project ID:</strong> {contract.projectId}</div>
//                 <div><strong>Project Title:</strong> {contract.title}</div>
//                 <div><strong>Transaction ID:</strong> {contract.transactionId}</div>

//                 {contract.document_id ? (
//                   <div><strong>Document ID:</strong> {contract.document_id}</div>
//                 ) : (
//                   <div className="text-muted">
//                     <em style={{ color: "grey" }}>No contract signed for this TransactionId.</em>
//                   </div>
//                 )}
//               </div>

//               <div className="cl-contract-actions">
//                 {/*  Company & Contributor Statuses (always show Pending if missing) */}
//                 <div className="dual-status-vertical">
//                   <div className="status-line">
//                     <strong> Company:</strong>{" "}
//                     <span className={`status-badge ${getStatusClass(contract.company_status)}`}>
//                       {contract.company_status || "Pending"}
//                     </span>
//                   </div>
//                   <div className="status-line">
//                     <strong> Contributor:</strong>{" "}
//                     <span className={`status-badge ${getStatusClass(contract.contributor_status)}`}>
//                       {contract.contributor_status || "Pending"}
//                     </span>
//                   </div>
//                 </div>

//                 {/*  Download Button */}
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => downloadContractPDF(contract.document_id, contract.transactionId)}
//                   disabled={!contract.document_id || loadingDocId === contract.transactionId}
//                 >
//                   {loadingDocId === contract.transactionId ? (
//                     <div className="pdf-loading">
//                       <div className="spinner"></div>
//                       <span>Loading...</span>
//                     </div>
//                   ) : (
//                     " Download"
//                   )}
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ContractsListPage;




import React, { useEffect, useState } from "react";
import "../CSS/contractsList.css";
import { BASE_API_URL } from "../constants";

const ContractsListPage = () => {
  const [contracts, setContracts] = useState([]);
  const [loadingDocId, setLoadingDocId] = useState(null);

  useEffect(() => {
    const fetchContracts = async () => {
      const userId = sessionStorage.getItem("userId");
      if (!userId) return;

      try {
        const res = await fetch(`${BASE_API_URL}/api/contracts/${userId}`);
        const data = await res.json();
        if (!data.contracts) return;

        const updatedContracts = await Promise.all(
          data.contracts.map(async (contract) => {

            try {
              // Step 1 Get document_id
              const docIdRes = await fetch(`${BASE_API_URL}/api/contracts/get-document-id`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  transactionId: contract.transactionId,
                  userId,
                }),
              });

              if (!docIdRes.ok)
                return {
                  ...contract,
                  document_id: null,
                  company_status: "Pending",
                  contributor_status: "Pending",
                };

              const docIdData = await docIdRes.json();
              const documentId = docIdData.document_id;

              //  If no document ID  show both as Pending
              if (!documentId) {
                return {
                  ...contract,
                  document_id: null,
                  company_status: "Pending",
                  contributor_status: "Pending",
                };
              }

              // Step 2 Fetch document details (statuses)
              const docDetailsRes = await fetch(`${BASE_API_URL}/api/get-doc-details/${documentId}`);
              if (!docDetailsRes.ok) {
                return {
                  ...contract,
                  document_id: documentId,
                  company_status: "Pending",
                  contributor_status: "Pending",
                };
              }

              const docDetails = await docDetailsRes.json();
              const signingParties = docDetails.data?.signing_parties || [];
              console.log("SIGNING PARTIES", signingParties);

              // Find company & contributor
              const companyParty = signingParties.find(
                (p) => p.identifier === "contract@cinevestor.in"
              );

              const contributorParty = signingParties.find(
                (p) => p.identifier !== "contract@cinevestor.in"
              );
              //  Fallback to Pending if missing
              return {
                ...contract,
                document_id: documentId,
                company_status: companyParty?.status || "Pending",
                contributor_status: contributorParty?.status || "Pending",
              };
            } catch (err) {
              console.error("Error fetching document details:", err);
              return {
                ...contract,
                document_id: null,
                company_status: "Pending",
                contributor_status: "Pending",
              };
            }
          })
        );

        setContracts(updatedContracts);
      } catch (err) {
        console.error("Error fetching contracts:", err);
      }
    };

    fetchContracts();
  }, []);

  const downloadContractPDF = async (documentId, transactionId) => {
    try {
      if (!documentId) {
        alert(" No document_id found!");
        return;
      }

      setLoadingDocId(transactionId);

      const url = `${BASE_API_URL}/api/download-document?document_id=${documentId}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch PDF");

      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `Contract_${documentId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Error downloading PDF:", err);
      alert(" Failed to download the document.");
    } finally {
      setLoadingDocId(null);
    }
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "requested":
        return "status-requested";
      case "sequenced":
        return "status-sequenced";
      case "completed":
        return "status-completed";
      case "failed":
        return "status-failed";
      case "pending":
        return "status-pending";
      default:
        return "status-default";
    }
  };

  return (
    <div className="cl-app-container">
      <main className="cl-main-content">
        <h1 className="cl-page-title">Contracts List</h1>

        {contracts.length === 0 && <p>No contracts found.</p>}

        <div className="cl-contracts-container">
          {contracts.map((contract, idx) => (
            <div key={idx} className="cl-contract-card">
              <div className="cl-contract-info">
                <div><strong>Project ID:</strong> {contract.projectId}</div>
                <div><strong>Project Title:</strong> {contract.title}</div>
                <div><strong>Transaction ID:</strong> {contract.transactionId}</div>

                {contract.document_id ? (
                  <div><strong>Document ID:</strong> {contract.document_id}</div>
                ) : (
                  <div className="text-muted">
                    <em style={{ color: "grey" }}>No contract signed for this TransactionId.</em>
                  </div>
                )}
              </div>

              <div className="cl-contract-actions">
                {/*  Company & Contributor Statuses */}
                <div className="dual-status-container">
                  <span className="status-label">
                    <strong> Company:</strong>{" "}
                    <span className={`status-badge ${getStatusClass(contract.company_status)}`}>
                      {contract.company_status}
                    </span>
                  </span>
                  <span className="status-separator">|</span>
                  <span className="status-label">
                    <strong> Contributor:</strong>{" "}
                    <span className={`status-badge ${getStatusClass(contract.contributor_status)}`}>
                      {contract.contributor_status}
                    </span>
                  </span>
                </div>

                {/*  Download Button */}
                <button
                  className="btn btn-secondary"
                  onClick={() => downloadContractPDF(contract.document_id, contract.transactionId)}
                  disabled={!contract.document_id || loadingDocId === contract.transactionId}
                >
                  {loadingDocId === contract.transactionId ? (
                    <div className="pdf-loading">
                      <div className="spinner"></div>
                      <span>Loading...</span>
                    </div>
                  ) : (
                    " Download"
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default ContractsListPage;
